import React from 'react';
import { Typography } from '@mui/material';

import type { HandoverPreviewRow } from '../../../services/admissions/handoverService';

/**
 * An applicant waiting to be enrolled: name, with their application number
 * muted underneath — and the GR number of a returning student, who keeps
 * theirs. First-time students get a GR number when the handover runs.
 */
const HandoverApplicantName: React.FC<{ row: HandoverPreviewRow }> = ({ row }) => (
  <>
    <Typography variant="body2" fontWeight={600}>{row.name}</Typography>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontFamily: 'monospace' }}>
      {[row.applicationNumber, row.grNumber && `GR ${row.grNumber}`].filter(Boolean).join(' · ')}
    </Typography>
  </>
);

export default HandoverApplicantName;
